
import genericUserImage from '../../assets/images/genericProfileImage.jpg';
import settings from "../../app-settings.json";
import { StorageKeys } from "../storage/StorageKeys";
import storageService from "../storage/storage-service/StorageService";
import restService from "../rest-service/RestService";
import { IeLynxUser } from "../../common/models/eLynxUser";
import { AuthenticationResultEnum } from "../../common/enums/AuthenticationResultEnum";
import { IApiKeyModel } from './Models';
import { IRecipient } from '../../common/models/IRecipient';

type IUserQueryParams = {
    contextGroupID: number;
};

type IUserIDTokenQueryParams = {
    clientID: string;
}

type IOtpValidationRequest = {
    otp: string;
    authenticationGuid: string;
}

type IAuthenticatorSecretRequest = {
    authenticationGuid: string;
    secret: string;
}



const UserDataService = {
    getIsSSO: function() : boolean {
        return storageService.local.get<boolean>(StorageKeys.IsSSO, false);
    },
    getUserImage: async function(userID: number, abortSignal?: AbortSignal): Promise<string> {
        const response = await restService.get<string>(`/users/${userID}/image`, abortSignal);

        let data = response.data && response.data.length ? response.data : genericUserImage;

        return data;
    },    

    saveUserImage: async function(contextGroupID: number, userID: number, file: File): Promise<void> {

        let formData = new FormData();
        formData.append("file", file);

        const queryParams: IUserQueryParams = {
            contextGroupID: contextGroupID,
        };

        await restService.post<FormData, void, IUserQueryParams>(`/users/${userID}/image`, formData, undefined, "multipart/form-data", queryParams);
    },

    saveUserProfile: async function(user: IeLynxUser): Promise<IeLynxUser> {
        const response = await restService.put<IeLynxUser, IeLynxUser>(`/userprofile`, user);
        return response.data;
    },
    validateCurrentPassword: async function(user: IeLynxUser): Promise<AuthenticationResultEnum> {
        const response = await restService.post<IeLynxUser, AuthenticationResultEnum>(`/user/validate/credentials`, user);
        return response.data;
    },
    getUserIDToken: async function(): Promise<string> {

        const queryParams: IUserIDTokenQueryParams = {
            clientID: settings.aadClientID
        }

        const response = await restService.get<string, IUserIDTokenQueryParams>(`/useridtoken`, undefined, queryParams);

        return response.data;
    },
    requestAuthenticatorSecret: async function(): Promise<IAuthenticatorSecretRequest> {
        const response = await restService.post<void, IAuthenticatorSecretRequest>(`/user/requestAuthenticatorSecret`, undefined);
        return response.data;
    },
    validateOtp: async function(otp: string, authenticatorGuid?: string): Promise<AuthenticationResultEnum> {
        const data: IOtpValidationRequest = {
            otp: otp, 
            authenticationGuid: authenticatorGuid ?? ""
        };
        const response = await restService.post<IOtpValidationRequest, AuthenticationResultEnum>(`/user/validate/otp`, data);
        return response.data;
    },
    requestAPIKey: async function(userID: number): Promise<void> {

        await restService.put<undefined, void>(`/users/${userID}/apikey`, undefined);
    },
    regenerateAPIKey: async function(userID: number, model: IApiKeyModel): Promise<IApiKeyModel> {
        const response = await restService.post<IApiKeyModel, IApiKeyModel>(`/users/${userID}/apikey/regenerate`, model);
        return response.data;
    },
    revokeAPIKey: async function(userID: number, model: IApiKeyModel): Promise<IApiKeyModel> {
        const response = await restService.post<IApiKeyModel, IApiKeyModel>(`/users/${userID}/apikey/revoke`, model);
        return response.data;
    },
    renewAPIKey: async function(userID: number, model: IApiKeyModel): Promise<IApiKeyModel> {
        const response = await restService.post<IApiKeyModel, IApiKeyModel>(`/users/${userID}/apikey/renew`, model);
        return response.data;
    },
    getUserRecipients: async function(contextGroupID: number, userID: number, abortSignal?: AbortSignal): Promise<IRecipient[]> {

        const queryParams: IUserQueryParams = {
            contextGroupID: contextGroupID,
        };

        const response = await restService.get<IRecipient[], IUserQueryParams>(`/users/${userID}/recipients`, abortSignal, queryParams);

        return response.data;
    },    
};

export default UserDataService;